import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found">
            <img 
                src="/images/404.jpeg" 
                alt="404 Not Found" 
                className="not-found-image" 
            />
            <p className="not-found-text">Oops! The page you're looking for doesn't exist.</p>
        </div>
    );
};

export default NotFound;